import { BAND_COLORS, BAND_LABELS, bandFor, formatScore } from "@/lib/scoring";

export default function ScoreBadge({ score, label, size = "md", testId }) {
  const band = bandFor(score);
  const color = BAND_COLORS[band];
  const dim = size === "lg" ? "h-24 w-24 text-3xl" : size === "sm" ? "h-12 w-12 text-base" : "h-16 w-16 text-2xl";
  return (
    <div className="flex items-center gap-4" data-testid={testId}>
      <div
        className={`relative ${dim} rounded-full flex items-center justify-center font-outfit font-semibold`}
        style={{
          background: `${color}22`,
          color,
          boxShadow: `inset 0 0 0 2px ${color}55`,
        }}
      >
        {formatScore(score)}
      </div>
      {label && (
        <div>
          <p className="tk-label">{label}</p>
          <p className="font-dmsans text-sm text-ink-900 mt-0.5">{BAND_LABELS[band]}</p>
        </div>
      )}
    </div>
  );
}
